module.exports = __webpack_public_path__ + "img/icon_robot.987d03a5.png";